/**
 * Registry de schemas de precificação por produto.
 *
 * Para adicionar um novo schema:
 *   1. Crie o componente em components/platform/ (ou nesta pasta)
 *   2. Adicione uma entrada aqui com a chave que ficará em product.integrations.pricingSchema
 *
 * Não é necessário modificar nenhum outro arquivo.
 */

import { lazy, ComponentType } from 'react';

export interface PricingSchemaEntry {
  label: string;
  /** Componente que gerencia toda a UI de precificação para este schema. Recebe productId. */
  Component: ComponentType<{ productId: string }>;
}

export const PRICING_SCHEMA_REGISTRY: Record<string, PricingSchemaEntry> = {
  vbody: {
    label: 'V-Body (planos simples)',
    Component: lazy(() => import('../IbodyPricingTab').then(m => ({ default: m.IbodyPricingTab })))
  }
  // Exemplo de como adicionar um novo schema no futuro:
  // vnova: {
  //   label: 'V-Nova (descrição do schema)',
  //   Component: lazy(() => import('../VNovaPricingTab').then(m => ({ default: m.VNovaPricingTab })))
  // }
};
